<template>
  <basic-layout-dynamic>
    <div class="container">
      <div class="contents">
        <div class="table-container">
          顧客属性一覧
          <md-table>
            <md-table-row
              v-for="inputName in customerAttribute"
              :key="inputName"
            >
              <md-table-cell md-label="名称" class="label-name">
                {{ inputName }}
              </md-table-cell>
              <md-table-cell>
                <gl-button icon-button @click="deleteRequest(inputName)">
                  <gl-icon-delete class="delete-icon"></gl-icon-delete>
                </gl-button>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <md-button
            class="md-raised md-primary"
            @click="showUploadDialog = true"
          >
            <md-icon>upload_file</md-icon>
            ファイルをアップロードする
          </md-button>

          <md-dialog :md-active.sync="showUploadDialog" class="dialog-window">
            <md-dialog-title>
              <div class="file">
                <div class="file-name">
                  <font-awesome-icon
                    class="icon icon-with-text"
                    icon="file-alt"
                  >
                  </font-awesome-icon>
                  <a href="#" @click.prevent="$refs.file.click()">
                    {{ filename }}
                  </a>
                </div>
                <input
                  hidden
                  ref="file"
                  type="file"
                  accept=".txt,.csv"
                  multiple
                  @change="setFiles($event.target.files)"
                  :disabled="showProgressDialog"
                />
              </div>
            </md-dialog-title>

            <md-dialog-content>
              <md-field>
                <md-input
                  v-model="inputName"
                  :maxlength="50"
                  required
                  :disabled="showProgressDialog"
                />
              </md-field>
            </md-dialog-content>
            <md-dialog-actions>
              <gl-button
                @click="showUploadDialog = false"
                :disabled="showProgressDialog"
              >
                キャンセル
              </gl-button>
              <gl-button
                class="md-primary"
                @click="save"
                :disabled="!hasInvalidInput || showProgressDialog"
              >
                save
              </gl-button>
            </md-dialog-actions>
          </md-dialog>

          <md-dialog
            :md-active.sync="showProgressDialog"
            :md-close-on-esc="false"
            :md-click-outside-to-close="false"
          >
            <md-dialog-content>
              <div style="display:flex;align-items:center">
                <spinner :diameter="30" />
                <span style="margin-left:var(--spacing-medium)">
                  顧客属性ファイルを{{ progressDialogMessage }}しています...
                </span>
              </div>
            </md-dialog-content>
          </md-dialog>
        </div>
      </div>
    </div>
  </basic-layout-dynamic>
</template>

<script>
import DialogConfirmation from '@/components/DialogConfirmation.vue'
import { filter } from 'rxjs/operators'
import Spinner from '@/components/Spinner.vue'

export default {
  components: { Spinner },
  props: {},
  data() {
    return {
      customerAttribute: [],
      showUploadDialog: false,
      inputName: '',
      file: undefined,
      showProgressDialog: false,
      progressDialogMessage: '',
    }
  },
  async mounted() {
    await this.loadCustomerAttribute()
  },
  computed: {
    filename() {
      return this.file ? this.file.name : 'ファイルを選択してください'
    },
    hasInvalidInput() {
      return (
        this.inputName.trim() !== '' &&
        this.inputName.length <= 50 &&
        this.file !== undefined
      )
    },
  },
  methods: {
    async setFiles(files) {
      if (files.length === 0) {
        return
      }
      this.file = files[0]
    },
    openDialog() {
      this.showUploadDialog = true
    },
    async loadCustomerAttribute() {
      this.progressDialogMessage = '取得'
      this.showProgressDialog = true
      this.customerAttribute = await this.$repositories
        .get('userCustomerAttribute')
        .get()
      this.showProgressDialog = false
    },
    async save() {
      this.progressDialogMessage = 'アップロード'
      this.showProgressDialog = true

      const responseData = await this.$repositories
        .get('userCustomerAttribute')
        .upload(this.file, this.inputName)

      this.showProgressDialog = false

      if (!responseData) {
        alert('入力した名称は既に存在します')
        return
      }

      this.inputName = ''
      this.file = undefined
      this.showUploadDialog = false

      await this.loadCustomerAttribute()
    },
    async deleteRequest(inputName) {
      await this.$dialog
        .open(DialogConfirmation, {
          message: `「${inputName}」を削除します。`,
          buttonTextOk: '削除する',
        })
        .pipe(filter(response => response))
        .subscribe(async () => {
          this.progressDialogMessage = '削除'
          this.showProgressDialog = true
          await this.$repositories
            .get('userCustomerAttribute')
            .delete(inputName)

          this.showProgressDialog = false
          await this.loadCustomerAttribute()
        })
    },
  },
}
</script>
<style lang="scss" scoped>
.container {
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
}

.filter {
  align-items: center;
  display: flex;
  flex-direction: row;
}

.actions {
  align-items: center;
  display: flex;
  flex-direction: row;
  padding-left: var(--spacing-large);
}

.contents {
  width: auto;
  max-width: 1000px;
  padding-top: var(--spacing-large);
  padding-bottom: var(--spacing-large);
}

.file-name {
  font-size: 1.3rem;

  .icon {
    color: #00b0ff;
    margin-right: var(--spacing-small);
  }
}

.md-table-row {
  .delete-icon {
    color: #448aff;
  }
}

.dialog-window {
  min-width: 600px;
}
</style>
